import * as SelectPrimitive from "@radix-ui/react-select"
import React from "react"

import { CheckIcon, ChevronDownIcon, ChevronUpIcon } from "@/constants/icons"

const SelectItem = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Item>,
  SelectPrimitive.SelectItemProps
>(({ children, ...props }, forwardedRef) => {
  return (
    <SelectPrimitive.Item
      className={`relative flex select-none items-center rounded-md px-8 py-2 text-sm font-medium text-gray-900 focus:bg-gray-100 focus:outline-none radix-disabled:opacity-50`}
      {...props}
      ref={forwardedRef}
    >
      <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
      <SelectPrimitive.ItemIndicator
        className={`absolute left-2 inline-flex items-center radix-state-active:text-gray-900`}
      >
        <CheckIcon className={`h-4 w-4`} />
      </SelectPrimitive.ItemIndicator>
    </SelectPrimitive.Item>
  )
})

interface SelectProps extends SelectPrimitive.SelectProps {
  wrapperClassName?: string
  ariaLabel?: string
  htmlFor?: string
  labelID?: string
}

const Select = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Trigger>,
  SelectProps
>(
  (
    { children, wrapperClassName, labelID, ariaLabel, htmlFor, ...props },
    forwardedRef
  ) => {
    return (
      <div className={`${wrapperClassName}`}>
        <label id={labelID} htmlFor={htmlFor} className={`hidden`}>
          {ariaLabel}
        </label>
        <SelectPrimitive.Root {...props}>
          <SelectPrimitive.Trigger
            aria-labelledby={labelID}
            id={htmlFor}
            ref={forwardedRef}
            className={`peer flex w-full appearance-none items-center justify-between rounded-l-full bg-white  px-3  py-3  text-sm text-gray-900  focus:outline-none focus:ring-0`}
          >
            <SelectPrimitive.Value />
            <SelectPrimitive.Icon className={`ml-2`}>
              <ChevronDownIcon className={`h-6 w-6`} />
            </SelectPrimitive.Icon>
          </SelectPrimitive.Trigger>
          <SelectPrimitive.Content
            className={`!max-h-[none] !overflow-visible rounded-lg bg-white p-2 shadow-lg`}
          >
            <SelectPrimitive.ScrollUpButton
              className={`flex items-center justify-center text-gray-900 `}
            >
              <ChevronUpIcon className={`h-6 w-6`} />
            </SelectPrimitive.ScrollUpButton>
            <SelectPrimitive.Viewport className={`!overflow-visible`}>
              {children}
            </SelectPrimitive.Viewport>
            <SelectPrimitive.ScrollDownButton
              className={`flex items-center justify-center text-gray-900`}
            >
              <ChevronDownIcon className={`h-6 w-6`} />
            </SelectPrimitive.ScrollDownButton>
          </SelectPrimitive.Content>
        </SelectPrimitive.Root>
      </div>
    )
  }
)

const SelectNamespace = Object.assign(Select, { Item: SelectItem })

export { SelectNamespace as Select }
